<div class="salesforce-lane">
  <div class="error-wrapper">
    <app-salesforce-error [chatId]="chatId"></app-salesforce-error>
  </div>
  <div class="bc-panel-header">
    <svg-icon icon="integration-salesforce-outline" class="bc-panel-header-icon"></svg-icon>
    <span class="bc-panel-header-text">{{ "salesforceLane.title" | translate }}</span>
  </div>

  <div class="list-view" *ngIf="createPanelState === bcEnums.salesforceCreate.CLOSE">
    <div class="search-wrapper">
      <svg-icon icon="magnifier"></svg-icon>
      <input type="text" class="search-field" (keypress)="onKeyPress($event)" placeholder="{{ 'salesforceLane.search' | translate }}" id="salesforce-search-field"/>
      <svg-icon *ngIf="isListFiltered" icon="x" (click)="onClearSearchButtonClicked()"></svg-icon>
      <span class="invalid-search" *ngIf="!isSearchValid">{{ "salesforceLane.invalidSearch" | translate }}</span>
    </div>

    <div class="group-list">
      <button *ngFor="let group of salesforceData"
              class="btn salesforce-group"
              (click)="loadGroupItems(group.id)"
              [ngClass]="{ 'btn-active': isGroupActive(group.id) }">
        <div class="btn-label" title="{{ group.name }}">{{ group.name }}</div>
        <div class="group-length-label">({{ group.items.length }})</div>
      </button>
    </div>

    <div *ngIf="!isLoading" class="expandable-item-container">
      <div *ngIf="selectedGroup?.items.length === 0">
        <span class="no-item-title">{{ "salesforceLane.noItemText.noItemFoundTitle" | translate: { itemName: selectedGroup.name } }}</span>
        <div class="no-item-description">
          <span>{{ "salesforceLane.noItemText.noItemFoundPreText" | translate }}</span>
          <a href>
            <span 
              *ngIf="hasCreatePermission" 
              data-automation-id="salesforce-lane-no-item-description" 
              (click)="openNewItemForm()">
                {{ "salesforceLane.noItemText.noItemFoundLink" | translate }}
            </span>
          </a>
          <span>{{ "salesforceLane.noItemText.noItemFoundPostText" | translate }}</span>
        </div>
      </div>

      <div class="expandable-item" *ngFor="let item of selectedGroup?.items">
        <div class="expand-item-details" (click)="toggleDetails(item)" [ngClass]="{ 'open': item.isDetailsOpen }">
          <div (click)="onLinkButtonClick(item, $event)">
            <button class="expandable-item-link-icon"
                    [ngClass]="getIconByLinkStatus(item.linked)"
                    [disabled]="isLinkButtonDisabled(item.linked)"
                    title="{{ getTooltipByLinkStatus(item.linked) | translate }}">
              <svg-icon icon="{{ getIconByLinkStatus(item.linked) }}"
                        [ngClass]="getIconByLinkStatus(item.linked)">
              </svg-icon>
            </button>
          </div>
          <div class="expandable-item-content">
            <span class="expandable-item-label">{{ item.name }}</span>
            <div class="detail-list description-list" *ngIf="hasFields(item) && !item.isDetailsOpen">
              <div class="item-detail" *ngFor="let field of item.fields">
                <span class="item-detail-name" title="{{ field.name }}">{{ field.name }}</span>
                <span class="item-detail-value" title="{{ field.value }}">{{ field.value }}</span>
              </div>
            </div>
          </div>
          <div class="expand-icon">
            <svg-icon icon="{{ getExpandIcon(item.isLoading) }}" [ngClass]="{'svg-icon-spin': item.isLoading}"></svg-icon>
          </div>
        </div>

        <div class="detail-list" *ngIf="item.isDetailsOpen && !item.isLoading">
          <div *ngFor="let section of item.sections">
            <div class="item-detail" *ngFor="let detail of section.fields">
              <span class="item-detail-name" title="{{ detail.name }}">{{ detail.name }}</span>
              <span class="item-detail-value" title="{{ detail.value }}">{{ detail.value }}</span>
            </div>
          </div>
          <div *ngIf="item.salesforceObjectUrl">
            <a class="open-object" target="_blank" (click)="openSalesforceObject(item.salesforceObjectUrl)">
              <svg-icon icon="pop-out"></svg-icon>
              <span class="open-object-text">{{ "salesforceLane.openObject" | translate }}</span>
            </a>
          </div>
          <div *ngIf="relations.length" class="salesforce-relations">
            <span class="salesforce-relations-title">{{ "salesforceLane.relationsTitle" | translate }}</span>
            <div class="salesforce-relations-button-group">
              <button 
                *ngFor="let relation of relations" 
                class="btn btn-light create-button" 
                (click)="openPrePopulatedItemFrom(relation, item)">
                  <svg-icon icon="plus"></svg-icon>
                  <span class="create-button-label">{{ relation }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-loading *ngIf="isLoading" [description]="'bcLoading.loadingText'"></app-loading>

    <div class="salesforce-footer">
      <button *ngIf="selectedGroup?.icon && selectedGroup?.id && hasCreatePermission" data-automation-id="salesforce-lane-create-button" class="btn btn-light create-button" (click)="openNewItemForm()">
        <svg-icon icon="{{ selectedGroup.icon }}"></svg-icon>
        <span class="create-button-label">{{ "salesforceLane.createNew" | translate: { itemName: selectedGroup.name } }}</span>
      </button>
    </div>
  </div>

  <div *ngIf="createPanelState === bcEnums.salesforceCreate.OPEN" class="salesforce-form-wrapper">
    <app-salesforce-form [prePopulateData]="prePopulateData" [group]="selectedGroup" [chatId]="chatId" (leaveCreate)="closeNewItemForm()" (saveAndLink)="loadSalesforceData(selectedGroup.id)"></app-salesforce-form>
  </div>
</div>
